import React from 'react';
import PropTypes from 'prop-types';
import ModalImage from 'react-modal-image'
import SocialIcons from '@components/SocialIcons';
import Nav from '@components/Nav';
import ScrollToNext from '@components/ScrollToNext';
import profile from '@images/jeongseok.jpg';

import './style.scss';

const LandingPage = (props, context) => {
  const { theme: { bgPrimary, colorPrimary } } = context;

  return (
    <div style={{ backgroundColor: bgPrimary }} className="landing-page">
      <Nav />
      <main style={{ color: colorPrimary }}>
        <div className="intro-wrapper">
          <div className="intro-profile">
            <div className="image-cropper">
              <ModalImage className="profile-image" small={profile} large={profile} />
            </div>
          </div>
          <div className="intro-name">Jeongseok Son</div>
          <div className="tagline">
            Member of Technical Staff @ OpenAI
          </div>
          <SocialIcons />
        </div>
      </main>
      <ScrollToNext pageSelector=".about-page" />
    </div>
  );
};

LandingPage.contextTypes = {
  theme: PropTypes.any
};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.js